import { get } from '../Config/config';


export const LeadSources = {
    get: (data) => get('/lead-source', { params: data }),

}

